import { FC, memo } from 'react'
import dynamic from 'next/dynamic'
import { TypeAdvertisingCardRestVariety } from '@shared/api/analytics/advertising/advertising'
import { PickAnalytic } from '@shared/api/analytics/types/types'
import { RestCardData, TemplateCardProps } from '@widgets/Restaurant/RestCards/RestCard/type/TemplateCardProps'
import List from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/List/List'
import Selection from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Selection/Selection'

const SpecialOffer = dynamic(
  () => import('@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/SpecialOffer/SpecialOffer'),
  { loading: () => null },
)

const NewDishes = dynamic(() => import('@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/NewDishes/NewDishes'), {
  loading: () => null,
})

const LookAlso = dynamic(() => import('@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/LookAlso/LookAlso'), {
  loading: () => null,
})

const GoThisWeek = dynamic(() => import('@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/GoThisWeek/GoThisWeek'), {
  loading: () => null,
})

const Booking = dynamic(() => import('@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Booking/Booking'), {
  loading: () => null,
})

const GigAssist = dynamic(() => import('@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/GigAssist/GigAssist'), {
  loading: () => null,
})

// list - Обычные списки
// special-offer - Спецпредложения
// new-dishes - Новые блюда
// look-also - Смотрите также
// selection - Подборки
// map - карточка на карте
// go-this-week - куда пойти на этой неделе
// booking - бронируйте прямо сейчас

// Секция в котором расположена карточка.
// Если это промо-карточка, то отправляется аналитика
export interface TypeAnalytic extends PickAnalytic<'section_name', 'section_index' | 'model_type' | 'provider'> {
  advertCardPlaceType: TypeAdvertisingCardRestVariety | null
}

const componentsByType = {
  list: List,
  'special-offer': SpecialOffer,
  'new-dishes': NewDishes,
  'look-also': LookAlso,
  selection: Selection,
  map: List,
  'go-this-week': GoThisWeek,
  booking: Booking,
  'gig-assist': GigAssist,
}

const RestCard: FC<TemplateCardProps<RestCardData>> = ({
  type,
  data,
  analytic,
  sizes = 'L',
  className = '',
  send_analytic,
  link,
  onClickInsteadLink,
  ...props
}) => {
  const Template = componentsByType[type as keyof typeof componentsByType] as FC<TemplateCardProps<RestCardData>>

  return (
    <Template
      type={type}
      analytic={analytic}
      data={data}
      sizes={sizes}
      className={className}
      send_analytic={send_analytic}
      link={link}
      onClickInsteadLink={onClickInsteadLink}
      {...props}
    />
  )
}

export default memo(RestCard)
